import * as React from "react";
import { createRoot } from "react-dom/client";
import { initSentry } from "../lib/sentry";
import WebApp from "./components/WebApp";
import { FluentProvider, greenTheme } from "@cuntas-mitool/ui";

/* global document, HTMLElement */

const rootElement: HTMLElement | null = document.getElementById("container");
const root = rootElement ? createRoot(rootElement) : undefined;

initSentry('webapp');

// Render immediately — no Office.onReady needed for the web app
root?.render(
  <FluentProvider theme={greenTheme}>
    <WebApp />
  </FluentProvider>
);
